import { styled } from '@mui/material/styles';
import FuseMessage from '@fuse/core/FuseMessage';
import { memo, ReactNode, Suspense } from 'react';
import { Outlet } from 'react-router';
import { Layout1ConfigDefaultsType } from 'src/components/theme-layouts/layout1/Layout1Config';
import useFuseLayoutSettings from '@fuse/core/FuseLayout/useFuseLayoutSettings';
import FuseSuspense from '@fuse/core/FuseSuspense';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';
import FuseDialog from '@fuse/core/FuseDialog';
import PoweredByLayout1 from './components/PoweredByLayout1';

const Root = styled('div')(({ config }: { config: Layout1ConfigDefaultsType }) => ({
	...(config.mode === 'boxed' && {
		clipPath: 'inset(0)',
		maxWidth: `${config.containerWidth}px`,
		margin: '0 auto',
		boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
	}),
	...(config.mode === 'container' && {
		'& .container': {
			maxWidth: `${config.containerWidth}px`,
			width: '100%',
			margin: '0 auto'
		}
	})
}));

type Layout1Props = {
	children?: ReactNode;
};

/**
 * The layout 1.
 */
function Layout1(props: Readonly<Layout1Props>) {
	const { children } = props;
	const settings = useFuseLayoutSettings();
	const config = settings.config as Layout1ConfigDefaultsType;

	return (
		<Root
			id="fuse-layout"
			config={config}
			className="flex flex-auto w-full"
		>
			<div className="flex min-w-0 flex-auto">
				{config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

				<main
					id="fuse-main"
					className="relative z-10 flex min-h-full min-w-0 flex-auto flex-col border-none"
				>
					{config.toolbar.display && (
						<ToolbarLayout1 className={config.toolbar.style === 'fixed' ? 'sticky top-0' : ''} />
					)}

					<div className="relative z-10 flex min-h-0 flex-auto flex-col">
						<Suspense>
							<FuseDialog />
						</Suspense>
						<FuseSuspense>
							<Outlet />
						</FuseSuspense>
						{children}
						<PoweredByLayout1 fixed={config.poweredBy?.fixed} />
					</div>
				</main>
			</div>

			<FuseMessage />
		</Root>
	);
}

export default memo(Layout1);
